import { homeConstants } from "../constants";

export default function (
  state = {
    isProgress: false,
    data: {},
    error: "",
  },
  action
) {
  switch (action.type) {
    case homeConstants.VERIFY_FORGOT_PASSWORD_REQUEST:
      return {
        ...state,
        isProgress: true,
      };
    case homeConstants.VERIFY_FORGOT_PASSWORD_SUCCESS:
      return {
        data: action.response.data,
        isProgress: false,
      };
    case homeConstants.VERIFY_FORGOT_PASSWORD_FAILURE:
      return {
        data: {},
        error: action.error,
        isProgress: false,
      };
    case homeConstants.RESET_DATA:
      return {
        ...state,
        data: {},
      };
    default:
      return state;
  }
}
